export default {
  dashboard: (state) => {
    return state.dashboard;
  },

  transactionReport: (state) => {
    return state.transactionReport;
  },
};
